import { render, staticRenderFns } from "./LayoutEditor.vue?vue&type=template&id=196dad81&scoped=true"
import script from "./LayoutEditor.vue?vue&type=script&lang=js"
export * from "./LayoutEditor.vue?vue&type=script&lang=js"
import style0 from "./LayoutEditor.vue?vue&type=style&index=0&id=196dad81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196dad81",
  null
  
)

export default component.exports